import React from "react";


export default function MatchesList({ sampleResult, baseURL }) {
    return (
        <>
         {(sampleResult.matches.map((match, index) => (
                    <div className="col-12 mt-3" key={index}>
                      <div className="row align-items-center">
                        <div className="col-sm-5 pe-sm-0">
                          <div className="bg-pro-con-ic">
                            <ul className="opd-pp-lists">
                              <li>
                                <span className="opd-pp-lbl" style={{ color: "#000" }}>
                                  {match.attribute}:
                                </span>
                                <span className="opd-pp-val">
                                  {" "}
                                  <span className="cBlur">{match.groomValue}</span>{" "}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div
                            className="partner-preficon"
                            style={{ background: match.isMatch ? "#eafaf1" : "#FFDFF2" }}
                          >
                            <img
                              src={`${process.env.PUBLIC_URL || ""}/assets/images/${match.isMatch ? "greentick" : "red-cross"}.png`}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="col-sm-5 ps-sm-0">
                          <div className="bg-pro-con-ic rht">
                            <ul className="opd-pp-lists">
                              <li>
                                <span className="opd-pp-lbl" style={{ color: "#000" }}>
                                  {match.attribute}:
                                </span>
                                <span className="opd-pp-val">
                                  {" "}
                                  <span className="cBlur">{match.brideValue}</span>{" "}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  )))}
        </>
    );
}